// Overlap detection for extracted economy reports — MIRROR of
// backend/lib/economy-report-overlap.js, keep the rules identical. Two reports
// describe the same money when they are of the same kind, from the same sales
// unit, and their periods intersect (a weekly and a monthly Vipps export).
// Only reports with includeInSum !== false count in any sum.

const norm = value => String(value || '').trim().toLowerCase();

export function sameUnit(a, b) {
    const an = norm(a.vippsNumber);
    const bn = norm(b.vippsNumber);
    if (an && bn) return an === bn;
    const au = norm(a.salesUnit);
    const bu = norm(b.salesUnit);
    if (au && bu) return au === bu;
    return !an && !bn && !au && !bu;
}

export function periodsIntersect(a, b) {
    if (!a.periodFrom || !a.periodTo || !b.periodFrom || !b.periodTo) return false;
    return a.periodFrom <= b.periodTo && b.periodFrom <= a.periodTo;
}

export function reportsOverlap(a, b) {
    if (!a || !b) return false;
    if (a.md5 && b.md5 && a.md5 === b.md5) return false;
    if ((a.kind || 'other') !== (b.kind || 'other')) return false;
    if (a.kind === 'other') return false;
    return sameUnit(a, b) && periodsIntersect(a, b);
}

export function isIncluded(report) {
    return !!report && report.includeInSum !== false;
}

// The other reports in `all` that overlap `report` (itself excluded).
export function overlapsFor(report, all) {
    return (Array.isArray(all) ? all : [])
        .filter(r => r && r !== report && !(report.id && r.id === report.id) && reportsOverlap(report, r));
}

// Included reports only — what every sum on the page is built from.
export function includedReports(reports) {
    return (Array.isArray(reports) ? reports : []).filter(isIncluded);
}

// True when two INCLUDED reports overlap each other — the sum is then
// double counting and the page should say so.
export function hasIncludedOverlap(reports) {
    const included = includedReports(reports);
    return included.some((a, i) => included.slice(i + 1).some(b => reportsOverlap(a, b)));
}
